import React from "react";
import { Select, MenuItem, IconButton, SelectProps, Box, InputLabel, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface Option {
    value: string | number;
    label: string;
    ativo?: string;
}

interface SelectPersonalizadoProps {
    value: string | undefined;
    onChange: (value: any) => void;
    sx?: any;
    disabled?: boolean;
    required?: boolean;
    MenuProps?: any;
    options: Option[];
    label: string;
    error?: boolean;
}

const SelectPersonalizado: React.FC<SelectPersonalizadoProps> = ({
    value,
    onChange,
    sx,
    disabled,
    required,
    MenuProps,
    options,
    label,
    error
}) => {

    const renderValue = (selected: any) => {
        if (!selected && selected !== 0) {
            return <InputLabel sx={{ fontSize: '14px' }} >{label}</InputLabel>
        }

        const opt = options.find((o) => String(o.value) === String(selected));

        if (!opt) {
            return <span style={{ color: "red" }}>{`(inativo) ${selected}`}</span>;
        }

        const isAtivo = (opt.ativo ?? "S") === "S";

        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <span
                    style={{
                        textDecoration: isAtivo ? "none" : "line-through",
                        opacity: isAtivo ? 1 : 0.5,
                        fontStyle: isAtivo ? "normal" : "italic",
                    }}
                >
                    {opt.label}
                </span>
                <Tooltip title="Limpar">
                    <IconButton
                        size="small"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={() => onChange("")}
                        disabled={disabled}
                        aria-label="Limpar seleção"
                    >
                        <ClearIcon sx={{ fontSize: 13 }} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    return (
        <Select
            value={value ?? ""}
            size="small"
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            required={required}
            sx={{
                fontSize: '14px',
                ...(error && {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ec6161',
                       
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ec6161',
                    },
                })
            }}
            renderValue={renderValue}
            MenuProps={MenuProps}
            displayEmpty
            error={error}
        >
            {options.map((opt) => {
                const isAtivo = (opt.ativo ?? "S") === "S";
                return (
                    <MenuItem
                        key={opt.value}
                        value={opt.value}
                        disabled={!isAtivo}
                        sx={{
                            opacity: isAtivo ? 1 : 0.5,
                            textDecoration: isAtivo ? "none" : "line-through",
                            fontStyle: isAtivo ? "normal" : "italic",
                            fontSize: '14px'
                        }}
                    >
                        {opt.label}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default SelectPersonalizado;